<div class="bk-accordion-area ptb--150 ptb-md--80 ptb-sm--60 bg_color--1">
    <div class="container">
        <div class="row">
            <!-- Start Single Accordion -->
            <div class="col-lg-6">
                <div class="thumb">
                    <img class="w-100" src="assets/img/nosotros/ana-silvia.jpg" alt="Ana Silvia Lara">
                </div>
            </div>
            <!-- End Single Accordion -->

            <!-- Start Single Accordion -->
            <div class="col-lg-6 mt_md--40 mt_sm--40">
                <div class="brook-section-title mb--50 mb_md--20 mb_sm--20">
                    <h3 class="heading heading-h3">ANA SILVIA, <span>FUNDADORA</span></h3>
                </div>
                <div class="bk-accordion-style--2" id="accordionExampl3">

                    <div class="card">
                        <div class="card-header" id="headingsix">
                            <h5 class="mb-0">
                                <a href="#" class="acc-btn" data-toggle="collapse" data-target="#collapsesix"
                                    aria-expanded="false" aria-controls="collapsesix">
                                    Biografía
                                </a>
                            </h5>
                        </div>

                        <div id="collapsesix" class="collapse" aria-labelledby="headingsix" data-parent="#accordionExampl3">
                            <div class="card-body">Ana Silvia Lara comparte la certificación de Neuro Akashico®, un avance en neurociencias en México y al rededor del mundo; escribe artículos para periódicos y redes sociales, ha sido invitada a programas de televisión y radio en México.
                            </div>
                        </div>
                    </div>

                    <div class="card">
                        <div class="card-header" id="headingseven">
                            <h5 class="mb-0">
                                <a href="#" class="acc-btn collapsed" data-toggle="collapse" data-target="#collapseseven"
                                    aria-expanded="false" aria-controls="collapseseven">
                                    Misión
                                </a>
                            </h5>
                        </div>
                        <div id="collapseseven" class="collapse" aria-labelledby="headingseven" data-parent="#accordionExampl3">
                            <div class="card-body">«Mi misión es enseñar y transmitir mis conocimientos con amor y luz, creando y generando consciencia ilimitada para la humanidad y el mundo que habitamos.»
                            </div>
                        </div>
                    </div>

              


                </div>
            </div>
            <!-- End Single Accordion -->
        </div>
    </div>
</div>

